import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTradingViewCandles: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="trading-view-candles"><path d="M7 2.75V10.75M7 10.75H3.75V18.25H7M7 10.75H10.25V18.25H7M7 18.25V21.25M17 2.75001V5.75M17 5.75H13.75V18.25H17M17 5.75H20.25V18.25H17M17 18.25V21.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconTradingViewCandles;
